(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // ---- page-ready fade ----
  requestAnimationFrame(function () {
    var page = document.querySelector('.page');
    if (page) page.classList.add('ready');
  });

  // ---- reduced-motion video pause ----
  function applyMotion() {
    document.querySelectorAll('video').forEach(function (v) {
      if (reduce.matches) {
        try { v.pause(); v.removeAttribute('autoplay'); } catch (e) {}
      } else {
        try { v.play().catch(function () {}); } catch (e) {}
      }
    });
  }
  applyMotion();
  if (reduce.addEventListener) reduce.addEventListener('change', applyMotion);
  else if (reduce.addListener) reduce.addListener(applyMotion);

  // ---- mobile drawer ----
  var drawer = document.getElementById('nav-drawer');
  var burger = document.querySelector('.nav__burger');
  if (drawer && burger) {
    var lastFocus = null;
    function openDrawer() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', 'Close menu');
      document.body.classList.add('is-drawer-open');
      var firstLink = drawer.querySelector('.drawer__link');
      if (firstLink) setTimeout(function () { firstLink.focus(); }, 360);
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('is-drawer-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
    burger.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeDrawer(); else openDrawer();
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    var mq = window.matchMedia('(min-width: 901px)');
    var handler = function (e) {
      if (e.matches && drawer.classList.contains('is-open')) closeDrawer();
    };
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else if (mq.addListener) mq.addListener(handler);
  }

  // ---- scroll-linked logo morph + nav is-scrolled ----
  var nav = document.querySelector('.nav');
  var hero = document.querySelector('.hero');
  var brandImg = document.querySelector('.nav__brand img');
  if (nav && hero && brandImg) {
    var ticking = false;
    var navH = 96, heroH = 0, heroTop = 0, lastP = -1, isScrolled = false;
    function cacheMetrics() {
      var rect = hero.getBoundingClientRect();
      navH = nav.offsetHeight || 96;
      heroH = rect.height;
      heroTop = rect.top + (window.pageYOffset || window.scrollY || 0);
      lastP = -1;
    }
    function measure() {
      ticking = false;
      var travel = Math.max(1, heroH - navH);
      var scrolled = Math.max(0, (window.pageYOffset || window.scrollY || 0) - heroTop);
      var p = Math.min(1, scrolled / travel);
      if (Math.abs(p - lastP) < 0.01 && (p >= 0.98) === isScrolled) return;
      lastP = p;
      var pStr = p.toFixed(2);
      brandImg.style.setProperty('--logo-progress', pStr);
      hero.style.setProperty('--logo-progress', pStr);
      var nextScrolled = p >= 0.98;
      if (nextScrolled !== isScrolled) {
        isScrolled = nextScrolled;
        nav.classList.toggle('is-scrolled', isScrolled);
      }
    }
    function onScroll() {
      if (!ticking) { requestAnimationFrame(measure); ticking = true; }
    }
    function onResize() { cacheMetrics(); measure(); }
    cacheMetrics();
    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
  } else if (nav) {
    nav.classList.add('is-scrolled');
  }
})();
